import React, { useState, useEffect } from 'react';
import { addDoc, collection, getFirestore, getDocs, writeBatch, where, query, documentId } from 'firebase/firestore';
export default function ItemsEditButton({id, name, time, price, render, adding, addNew, error, sub, active}) {

    const db = getFirestore()

    const [currentTime, setcurrentTime] = useState(time)
    const [currentName, setcurrentName] = useState(name)
    const [currentPrice, setcurrentPrice] = useState(price)
    const [currentSub, setcurrentSub] = useState(sub ? sub : "")
    const [newTime, setNewTime] = useState(time)
    const [newSub, setNewSub] = useState(sub)
    const [newName, setNewName] = useState(name)
    const [newPrice, setNewPrice] = useState(price)
    const [editing, setEditing] = useState(false)
    const [currentActive, setCurrentActive] = useState(active !== false)

    
    const handleTime = (event) => {
        setNewTime(event.target.value);
    }

    
    const handleName = (event) => {
      setNewName(event.target.value);
    }


    
    const handlePrice = (event) => {
        setNewPrice(event.target.value);
    }

        
    const handleSub = (event) => {
      setNewSub(event.target.value);
  }


    const editarF = () => {
      setcurrentName(null)
      setcurrentTime(null)
      setcurrentPrice(null)
      setcurrentSub(null)
      setEditing(true)
    }

    const confirm = async () => {

       
              const arr = [id.toString()]
      
             
              const queryCol = collection(db, `items`)
             
              const batch = writeBatch(db)
              const updateId = await query(
                  queryCol,
                where(documentId(), 'in', arr))
             
             
                
                 await getDocs(updateId)
                 .then(resp => resp.docs.forEach(res => {
                  batch.update(res.ref, {
                    price: newPrice === null ? Number(currentPrice) : Number(newPrice), 
                    time: newTime === null ? Number(currentTime) : Number(newTime), 
                    name: newName === null ? currentName : newName, 
                    sub: newSub === null ? currentSub : newSub,
                    active: currentActive
                  });
                })
                 )
                 await batch.commit(); 
            

        setEditing(false)
        render()
      }

    const toggleActive = async () => {
      const arr = [id.toString()]
      const queryCol = collection(db, `items`)
      const batch = writeBatch(db)
      const updateId = await query(queryCol, where(documentId(), 'in', arr))
      
      await getDocs(updateId)
        .then(resp => resp.docs.forEach(res => {
          batch.update(res.ref, { active: !currentActive });
        }))
      await batch.commit();
      
      setCurrentActive(!currentActive)
      render()
    }

  return (
    <div className='itemsEditInputsCont' style={{opacity: currentActive ? 1 : 0.7}}>
      <input className={editing === true ? 'itemsEditInput w30rem bgEditing' : 'itemsEditInput w30rem'} placeholder={name} value={currentName} onChange={handleName}>
      </input> 
     
      <input className= {editing === true ? 'itemsEditInput w5itemsrem bgEditing alignCenter2' : 'itemsEditInput w5itemsrem alignCenter2'} placeholder={time} value={currentTime} onChange={handleTime}>
      
      </input>

      <input className= {editing === true ? 'itemsEditInput w5itemsrem bgEditing alignCenter2' : 'itemsEditInput w5itemsrem alignCenter2'} placeholder={price} value={currentPrice} onChange={handlePrice}>

      </input>

      <input className= {editing === true ? 'itemsEditInput w5itemsrem bgEditing alignCenter2' : 'itemsEditInput w5itemsrem alignCenter2'} placeholder={sub ? sub : "Vacío"} value={currentSub} onChange={handleSub}>

      </input>

      {/* Toggle de estado */}
      <div className='itemsEditInput w5itemsrem alignCenter2' style={{display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}} onClick={toggleActive}>
        <div style={{
          width: '40px',
          height: '20px',
          backgroundColor: currentActive ? '#10b981' : '#ef4444',
          borderRadius: '10px',
          position: 'relative',
          transition: 'all 0.3s ease'
        }}>
          <div style={{
            position: 'absolute',
            left: currentActive ? '22px' : '2px',
            top: '2px',
            width: '16px',
            height: '16px',
            backgroundColor: 'white',
            borderRadius: '50%',
            transition: 'all 0.3s ease'
          }}></div>
        </div>
      </div>

      {adding === true ? 
      <button onClick={() => {
          addNew(newName, newTime, newPrice, newName, newSub)
      }} className='button2'>Agregar nuevo</button>
      : 
      <>    {editing === true ? <button onClick={confirm} className='button2'>Confirmar cambios</button> :     <button onClick={editarF} className='button2'>Editar</button>
  }</>
      }

      {error === true ? <button  className='cancelButton44 '>¡Ya existe un item con el mismo nombre!</button> : <></>}

    </div>
  )
}
